const register = {
  loginCredentials: "Inloggegevens", // translated
  companyInformation: "bedrijfsinformatie", // translated
  contactDetails: "Contact details", // translated
  businessName: "Bedrijfsnaam", // translated
  businessAddress: "Bedrijfsadres", // translated
  registrationCode: "Registratiecode", // translated
  websiteUrl: "Website URL", // translated
  mobilePhone: "Mobiele telefoon", // translated
  regionStateProvince: "Regio/Staat/Provincie", // translated
  legalTitle: "Legale titel", // translated
  city: "Stad", // translated
  postalCode: "Postcode", // translated
  registrationSuccess: "Registratie succes.", // translated
  pleaseWaitFewMomentsAndYouWillBeRedirectedToHome: "Wacht even en u wordt doorgestuurd naar de startpagina.", // translated
};

export default register;
